import './image-upload.scss';

import { Upload } from 'antd';

import { PlusOutlined } from '@/media/antd-icons';
import {
  IMAGE_UPLOAD_TYPES,
  type TUploadFileProblem,
  blobToBase64,
  getImageFileProblem
} from '@/shared/services/helpers/files';

interface IProps {
  /** Связывает поле с подписью `Form.Item`. */
  id?: string;
  /** Картинка — data URL или адрес. */
  value?: string;
  onChange: (value?: string) => void;
  /** Предельный размер файла в байтах. */
  maxSize: number;
  /** Подпись кнопки загрузки. */
  uploadLabel: string;
  /** Файл не подошёл: не картинка или слишком большой. */
  onProblem: (problem: TUploadFileProblem) => void;
}

/**
 * Загрузка одной растровой картинки (PNG, JPEG, WebP, GIF) с превью. Файл не уходит на сервер сам:
 * проверяется до чтения и хранится в форме как data URL до сохранения.
 */
const ImageUpload: React.FC<IProps> = ({
  id,
  value,
  onChange,
  maxSize,
  uploadLabel,
  onProblem
}) => (
  <Upload
    id={id}
    className="image-upload"
    listType="picture-card"
    accept={IMAGE_UPLOAD_TYPES.join(',')}
    maxCount={1}
    fileList={
      value ? [{ uid: 'image', name: 'image', status: 'done', url: value }] : []
    }
    showUploadList={{ showPreviewIcon: false }}
    beforeUpload={(file) => {
      const problem = getImageFileProblem(file, maxSize);
      if (problem) {
        onProblem(problem);
        return Upload.LIST_IGNORE;
      }
      void blobToBase64(file).then(onChange);
      return false;
    }}
    onRemove={() => onChange(undefined)}
  >
    {!value && (
      <span className="image-upload__button">
        <PlusOutlined />
        {uploadLabel}
      </span>
    )}
  </Upload>
);

export default ImageUpload;
